import enLogo from "../../assets/img/brand/an-en-logo.svg";
import enLogoSmall from "../../assets/img/brand/an-en-logo-small.svg";

interface BrandMarkSVGProps {
    className?: string;
}

// Tailwind's `sm` breakpoint is 640px — use the small variant below that.
const MOBILE_MEDIA = "(max-width: 640px)";

// Per QM: only the English wordmark is used, regardless of UI language.
const BrandMarkSVG = ({className}: BrandMarkSVGProps) => {
    return (
        <picture>
            <source media={MOBILE_MEDIA} srcSet={enLogoSmall}/>
            <img src={enLogo} alt="Accessory Navigator" className={className ?? "block h-auto w-full"}/>
        </picture>
    );
};

export default BrandMarkSVG;
